<template>
  <div class="w-full">
    <slot :current-src="currentSrc" />
    <div class="flex flex-row items-center justify-center w-full pt-4">
      <el-upload
        ref="uploader"
        action=""
        :show-file-list="false"
        :auto-upload="false"
      >
        <el-button
          type="text"
          @click.prevent
        >
          {{ $t('common.edit') }}
        </el-button>
      </el-upload>
      <el-button
        v-if="isRemovable"
        type="text"
        @click="onRemove"
      >
        {{ $t('common.remove') }}
      </el-button>
    </div>
  </div>
</template>
<script>

const REMOVE = '<remove>';

export default {
  props: {
    defaultSrc: {
      type: String,
      default: '',
    },
    value: {
      default: null,
    },
  },
  data() {
    return {
      isMounted: false,
      removePicture: false,
      uploadPreview: null,
    };
  },
  computed: {
    files() {
      if (!this.isMounted) {
        return null;
      }
      const files = this.$refs.uploader.uploadFiles;
      if (files && files.length) {
        return files;
      }
      return null;
    },
    uploadPicture() {
      if (this.removePicture) {
        return REMOVE;
      }
      if (this.files) {
        return this.files[this.files.length - 1].raw;
      }
      return null;
    },
    currentSrc() {
      if (this.value !== REMOVE) {
        if (this.uploadPreview) {
          return { path: this.uploadPreview };
        }
        return this.defaultSrc;
      }
      return '';
    },
    isRemovable() {
      return this.value !== REMOVE && this.currentSrc;
    },
  },
  watch: {
    files(newVal) {
      if (newVal && newVal.length > 1) {
        this.files.splice(0, 1);
      }
      this.removePicture = false;
    },
    uploadPicture(newVal) {
      if (newVal === REMOVE) {
        this.$emit('input', REMOVE);
      } else if (newVal) {
        URL.revokeObjectURL(this.uploadPreview); // remove the old one
        this.uploadPreview = URL.createObjectURL(newVal);
        this.$emit('input', newVal);
      } else {
        this.uploadPreview = null;
        this.$emit('input', null);
      }
    },
  },
  mounted() {
    this.isMounted = true;
  },
  beforeDestroy() {
    URL.revokeObjectURL(this.uploadPreview); // remove if any
  },
  methods: {
    reset() {
      this.removePicture = false;
      this.$refs.uploader.clearFiles();
      URL.revokeObjectURL(this.uploadPreview); // remove if any
    },
    onRemove() {
      this.removePicture = true;
      this.$refs.uploader.clearFiles();
      URL.revokeObjectURL(this.uploadPreview); // remove if any
    },
  },
};
</script>
